module.exports = __webpack_public_path__ + "static/penguin-ba9dc240acd43907a4d9181f6b4e02c3.png";